<script>
    import spinner from "shared/Components/spinner.vue";
    import { String } from 'core-js';

    export default {
        props: {
            gray: Boolean,
            disabled: Boolean,
            text: String,
            nostyle: Boolean,
            fullWidth: Boolean,
            loading: Boolean,
            href: String,
            target: String
        },
        components: {
            spinner
        },
        methods: {
            click(e) {
                if(!this.disabled && !this.loading) {
                    this.$emit("click", e);
                    if(this.href) {
                        if(!this.target || this.target === "_self") {
                            window.location = this.href;
                        } else {
                            window.open(this.href);
                        }
                    }
                }
            },
            focus() {
                setTimeout(() => this.$refs.button.focus());
            }
        }
    }
</script>

<template>
    <div ref="button" :disabled="disabled" class="a" :class="{ gray: gray, button: !nostyle, fullwidth: fullWidth, loading: loading }" 
        :tabindex="disabled ? '-1' : '0'" role="button" @click="click" @keydown.enter.space="click">
        {{text}}
        <slot></slot>
        <spinner class="button-spinner" v-if="loading" :visible="loading" half></spinner>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .a {
        cursor: pointer;
        width: auto;
        display: inline-block;
        user-select: none;
    }

    .button {
        min-width: 226px;
        width: 226px;
        max-width: 100%;
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 10px;
        border: 1px solid @frontier-gray-lightest;
        background-color: @frontier-green;
        color: @white;
        line-height: 100%;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
        text-transform: uppercase;
        text-decoration: none;
        border-radius: 0;
        vertical-align: middle;
        position: relative;
        cursor: pointer !important;
        height: 52px;
        -moz-border-radius: 3px;
        -webkit-border-radius: 3px;
        border-radius: 3px;
        box-shadow: 1px 1px 2px rgba(46, 58, 48, 0.3);

        &:hover {
            background-color: #005639;
        }

        &:active {
            background-color: #005135;
        }

        &.loading {
            cursor: initial;
            &:hover, &:active {
                background-color: @frontier-green;
            }
        }

        &.gray {
            background-color: @frontier-gray-xxdark;

            &:hover, &:active {
                background-color: @frontier-gray;
            }
        }

        &.fullwidth {
            width: 100%;
        }

        &[disabled] {
            background-color: @frontier-gray-light;
            cursor: not-allowed !important;
            box-shadow: 0 0 0;

            &:hover, &:active {
                background-color: @frontier-gray-light;
            }
        }

        .button-spinner {
            position:absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255,255,255,0.4);
            cursor: default;
        }
    }

    @media @mobile{
        .button {
            width: 100%;
            font-size: 16px;
            min-width: auto;
        }
    }

    body.user-is-tabbing {
        [role='button']:focus {
            border: 4px solid #aaa;
        }
    }
</style>